import Header from "./Header";
import Footer from "./Footer";
import AffiliateTicker from "./AffiliateTicker";
import FloatingAffiliateButton from "./FloatingAffiliateButton";
import LiveMarketTicker from "./LiveMarketTicker";
import AffiliateAd from "./AffiliateAd";

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="fixed top-0 left-0 right-0 z-50">
        <Header />
        <LiveMarketTicker />
      </div>
      <div className="pt-28 md:pt-32">
        {/* <AffiliateTicker /> */}
        <main className="flex-1">{children}</main>
        <Footer />
        {/* <FloatingAffiliateButton /> */}
      </div>
      <AffiliateAd />
    </div>
  );
};

export default Layout;
